export const filterBarSearchStyle = {
  width: '100%',
  height: 42,
  boxSizing: 'border-box',
  padding: '0 48px 0 16px',
  border: '1px solid var(--careco-border)',
  borderRadius: 'var(--careco-rounded-sm)',
  backgroundColor: 'var(--careco-surface)',
  fontFamily: 'var(--careco-font)',
  fontSize: 14,
  color: 'var(--careco-text-primary)',
}

export const styles = () => ({
  container: {
    position: 'relative',
    overflow: 'hidden',
  },
  input: {
    width: '100%',
    height: 36,
    outline: 'none',
    border: '1px solid rgba(53, 64, 82, 0.1)',
    boxSizing: 'border-box',
    borderRadius: 4,
    padding: '8px 38px 8px 12px',
    fontSize: 14
  },
  icon: {
    position: 'absolute',
    right: 22,
    top: '50%',
    transform: 'translate(0%, -50%)',
    '& svg': {
      display: 'block'
    }
  },
})
